module.exports = "<ride-page></ride-page>\n";


//////////////////
// WEBPACK FOOTER
// ./src/views/appRoutes/ride.html
// module id = 1487
// module chunks = 0